import styled, { css, keyframes } from "styled-components";
import { appearFromLeft } from "./components/Create/1-Layout/styles";

export const grow = keyframes`
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
`;

export const opacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 94vh;
  padding: 25px 25px 50px 25px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
    background-color: #fcfcfc;
  }

  ::-webkit-scrollbar-thumb {
    background: #11a7d9;
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }

  ::-webkit-scrollbar-corner {
    background: #11a7d9;
  }
`;

export const Title = styled.h1`
  --gray: #444444;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 30px;
  line-height: 100%;
  color: var(--gray);
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? marginBottom : " 32px"};
`;

export const Subtitle = styled.h2`
  --gray: #3a3a3c;
  --OpenSans: "Open Sans", sans-serif;

  color: var(--gray);
  font-weight: 700;
  font-family: var(--OpenSans);
  font-size: 20px;
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : "100%")};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? marginBottom : "24px"};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : "16px")};
`;

export const Description = styled.p`
  --gray: #6c6c6c;
  --OpenSans: "Open Sans", sans-serif;

  color: var(--gray);
  font-family: var(--OpenSans);
  font-weight: 400;
  font-size: 18px;
  line-height: 170%;
  letter-spacing: 0%;

  & > span {
    font-weight: 600;
  }

  ${({ generate }) =>
    generate &&
    css`
      font-family: "Open Sans";
      font-weight: 400;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0%;

      & > span {
        font-weight: 600;
      }
    `};

  ${({ generateDesc }) =>
    generateDesc &&
    css`
      font-family: "Open Sans";
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0%;
    `};

  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? marginBottom : "24px"};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : "0")};
`;

export const Divider = styled.div`
  margin: ${({ margin }) => margin ?? "32px auto"};
  width: 100%;
  background-color: #dde5e9;
  height: 1px;

  ${({ animated }) =>
    animated &&
    css`
      width: 0%;
      animation: ${grow} 1s forwards;
    `}
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${(props) => props.direction ?? "row"};
  gap: ${(props) => props.gap ?? "16px"};
  width: ${(props) => props.width ?? "100%"};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : "0")};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : "0")};

  ${({ center }) => center && `justify-content: center`};
  ${({ spaceBetween }) => spaceBetween && `justify-content: space-between`};

  ${({ animated }) =>
    animated &&
    css`
      opacity: 0;
      animation: ${opacity} 1s forwards;
    `}
`;

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  ${({ animated }) =>
    animated &&
    css`
      animation: ${appearFromLeft} 1s;
    `}
`;
